import { type ReactElement, useContext } from 'react';

import { SlabTabs } from '../SlabTabs/SlabTabs';
import { SlabTabContext, type SlabTabListOption } from './SlabTabContext';
import { getPanelId, getTabId } from './utils';

interface SlabTabListProps<T extends string> {
  tabs: SlabTabListOption<T>[];
  onChangeTab(name: T): void;
  hideIfOnlyOneTab?: boolean;
}

export const SlabTabList = <T extends string>({
  tabs,
  onChangeTab,
  hideIfOnlyOneTab = false,
}: SlabTabListProps<T>): ReactElement | null => {
  const { activeTab } = useContext(SlabTabContext);

  if (!tabs.length) return null;

  if (hideIfOnlyOneTab && tabs.length === 1) return null;

  // The context is untyped, but the provider only ever holds one of these tab labels.
  return (
    <SlabTabs
      value={activeTab as T}
      onChange={onChangeTab}
      items={tabs.map(({ label, count }) => ({
        value: label,
        label,
        count,
        id: getTabId(label),
        panelId: getPanelId(label),
      }))}
    />
  );
};
